import { actiontype, changeMeter } from "../actions/scaleactions";

const initialState = {
  scale: [],
  postweight: [],
  printlabel: [],
  postprintlabel: [],
  selectedlocation: [],
  enterlocation: [],
  postorderprintlabel: [],
  postweightwip: [],
  weightmaster: [],
  postcancle: [],
  changemeter: []
};

export const scalereducers = (state = initialState, action: any) => {
  switch (action.type) {
    case actiontype.POST_ACCEEPT_ORDER:
      return {
        ...state,
        scale: action.payload,
      };
    case actiontype.POST_WEIGHT:
      return {
        ...state,
        postweight: action.payload,
      };
    case actiontype.GET_PRINTLABEL:
      return {
        ...state,
        printlabel: action.payload,
      };
    case actiontype.POST_PRINTLABEL:
      return {
        ...state,
        postprintlabel: action.payload,
      };
    case actiontype.SELECTED_LOCATION:
      return {
        ...state,
        selectedlocation: action.payload,
      };
    case actiontype.ENTER_LOCATION:
      return {
        ...state,
        enterlocation: action.payload,
      };
    case actiontype.POST_ORDERPRINTLABEL:
      return {
        ...state,
        postorderprintlabel: action.payload,
      };
    case actiontype.POST_WEIGHT_WIP:
      return {
        ...state,
        postweightwip: action.payload,
      };
    case actiontype.POST_WEIGHT_MASTER:
      return {
        ...state,
        weightmaster: action.payload,
      };
    case actiontype.POST_CANCEL_ORDER:
      return {
        ...state,
        postcancle: action.payload,
      };
    case actiontype.CHANGE_METER:
      return {
        ...state,
        changemeter: action.payload,
      };
    default:
      return state;
  }
};
export default scalereducers;
